import { withRouter, RouteComponentProps } from "react-router-dom";
import { session } from '../session';

export const Logout = withRouter((props: RouteComponentProps) => {
  session.destroy();
  window.location.pathname = '/'
  return null
})
